import createDiscontinuationElement from "./createDiscontinuationElement";

export default (roundData, pageData) => {

  const r = {};
  r.data = {
    round: roundData,
    page: pageData
  }
  const init = () => {
    console.log('buildSidebarRound', r.data);
    r.root = document.querySelector('.le-side-round').parentElement;

    buildAccordion();

    r.root.classList.remove('_skelton');
    r.root.removeAttribute('aria-hidden');
  }

  const buildAccordion = () => {
    const roundList = r.root.querySelector('.le-side-round__list');
    const roundListItem = roundList.firstElementChild;
    // console.log(roundListItem);

    const fragmentElement = document.createDocumentFragment();
    r.group = '';
    r.data.round.forEach(roundInfoObj => {
      // console.log({roundInfoObj})
      const cloneListItem = roundListItem.cloneNode(true);
      cloneListItem.classList.remove('_round', '_lead', '_event');
      if (roundInfoObj.isCurrent) {
        cloneListItem.classList.add('is-current');

        const dropdownTargetText = r.root.querySelector('.le-side-dropdown__target-txt');
        if (dropdownTargetText) {
          dropdownTargetText.innerHTML = `<span class="le-side-round__target-name">${roundInfoObj.title}</span><span class="le-side-round__target-date">${roundInfoObj.date}</span>`;
        }
        if (roundInfoObj.isDiscontinuation) {
          dropdownTargetText.after(createDiscontinuationElement('le-side-dropdown__target'));
        }
      }

      const link = cloneListItem.querySelector('.le-side-round__link');
      link.href = `/league/player/?year=${r.data.page.year}&season=${r.data.page.season}&round_code=${roundInfoObj.code}`;
      const txt = cloneListItem.querySelector('.le-side-round__link-txt');
      txt.innerHTML = `<span class="le-side-round__link-name">${roundInfoObj.title}</span><span class="le-side-round__link-date">${roundInfoObj.date}</span>`;

      if (roundInfoObj.isDiscontinuation) {
        link.appendChild(createDiscontinuationElement(link.className));
      }

      fragmentElement.appendChild(cloneListItem);
    });

    roundList.innerHTML = '';
    roundList.appendChild(fragmentElement);
  }

  init();
}
